export interface IPropTypes {
    onImport: () => void;
    onExport: () => void;
}

export enum DropdownValue {
    import = 'import',
    export = 'export',
}
